module.exports = __webpack_public_path__ + "static/pfagoraslabpro-bold.28b7469d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/pfagoraslabpro-bold.ttf
// module id = 323
// module chunks = 114276838955818